import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import { TextField, Loading, Select } from "components/form";
import * as Icons from "react-feather";
import { required, validationWrapper, number } from "lib/formValidations";
import {
  transformTranslateFromValues,
  transformTranslateServerValues,
} from "lib/helpers";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useList } from "store/list";
import { handleSuccessMessages } from "store/auth";
import AddSlide from "./AddSlide";
import EditSlide from "./EditSlide";

import { SortableContainer, SortableElement } from "react-sortable-hoc";
import cleanObject from "utils/editHelper";
import { cleanArray } from "utils/editHelper";
// import { arrayMoveImmutable } from "array-move";
// components

export default function Add(props) {
  const path = {
    baseRoute: "/slider-panel",
    aliasName: "اسلاید ها",
    type: "Sliders",
  };
  const navigator = useNavigate();
  const {
    dispatch,
    clear,
    load,
    update,
    getSingle,
    single,
    customRequest,
  } = useList();
  const [slides, setSlides] = useState([]);
  const [showAddSlide, setShowAddSlide] = useState(false);
  const [showEditSlide, setShowEditSlide] = useState(false);
  const [item, setItem] = useState(false);
  const { id } = useParams();
  const onSortEnd = async ({ oldIndex, newIndex }) => {
    setSlides(single?.data?.slides);
    setItem(single?.data);

    handleSuccessMessages("عملیات با موفقیت انجام شد");
  };

  const handleDeleteSlide = (item_id) => {
    const updatedSlides = slides?.filter((slide) => slide?.id !== item_id);
    setSlides(updatedSlides);

    handleSuccessMessages("عملیات با موفقیت انجام شد");
  };

  useEffect(() => {
    dispatch(getSingle(path, id));
  }, []);

  useEffect(() => {
    if (single && single?.data?.slides) {
      setSlides(single?.data?.slides);
      setItem(single?.data);
    }
  }, [single]);

  if (load) {
    return (
      <>
        <div className="content">
          <div className="p-3 flex justify-center">
            <Loading />
          </div>
        </div>
      </>
    );
  }

  function updateMediaIds(data) {
    if (!data || !data.slides) return data;

    return {
      ...data,
      slides: data.slides.map((slide) => ({
        ...slide,
        media: slide.media?.id || slide.media,
      })),
    };
  }

  return (
    <>
      <AddSlide
        slides={slides}
        setSlides={setSlides}
        show={showAddSlide}
        close={() => setShowAddSlide(false)}
        submit={(values) => {
          setSlides([...slides, values]);
          handleSuccessMessages("عملیات با موفقیت انجام شد");
        }}
      />

      <EditSlide
        slides={slides}
        setSlides={setSlides}
        show={showEditSlide}
        item={item}
        close={() => setShowEditSlide(false)}
        submit={(values) => {
          handleSuccessMessages("عملیات با موفقیت انجام شد");
        }}
      />

      <div className="content">
        <div className="w-full p-3 flex justify-between items-center">
          <h2>ایجاد اسلایدر</h2>
          <Link to="/settings/sliders" className="btn btn-info shadow-md mr-2">
            بازگشت
          </Link>
        </div>

        <hr className="my-3" />
        <div className="p-3 w-full flex gap-x-2">
          <div className="w-1/4">
            <Formik
              initialValues={{ ...single?.data }}
              onSubmit={async (values, { setSubmitting }) => {
                // delete values.slides;

                let clean = cleanObject(values, [
                  "id",
                  "updatedAt",
                  "uuid",
                  "createdAt",
                ]);

                clean.slides = slides;

                console.log("clean.slides: ", clean.slides);

                clean = updateMediaIds(clean);

                console.log("clean.slides1: ", clean.slides);

                const newSlides = cleanArray(clean.slides, [
                  "id",
                  "updatedAt",
                  "createdAt",
                ]);
                clean.slides = newSlides;

                await dispatch(
                  update(path, id, clean, () => {
                    handleSuccessMessages("عملیات با موفقیت انجام شد");
                    navigator("/settings/sliders");
                  })
                );
                setSubmitting(false);
              }}
              enableReinitialize
            >
              {({ isSubmitting, dirty, values }) => (
                <Form>
                  <div className="box rounded py-3">
                    <div className="p-3">
                      <div className="intro-x flex-col">
                        <Field
                          placeholder="صفحه اسلایدر"
                          label="صفحه اسلایدر :"
                          name="type"
                          component={TextField}
                        />

                        <button
                          className="mt-4 btn btn-primary w-20"
                          type="submit"
                          // disabled={!!(isSubmitting || !dirty)}
                        >
                          {isSubmitting ? <Loading /> : "ذخیره"}
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>

          <div className="w-3/4">
            <div className="box p-2">
              <div className="flex justify-between md:px-4 items-center">
                <h3>اسلاید ها : </h3>
                <button
                  className="btn btn-primary btn-sm my-3"
                  onClick={() => {
                    setShowAddSlide(true);
                  }}
                >
                  ایجاد اسلاید
                </button>
              </div>
              <hr className="my-2" />

              {/* slides List */}
              <div className="mt-3">
                <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
                  <table className="table table-report text-xs -mt-2">
                    <thead>
                      <tr>
                        <th className="whitespace-nowrap text-center w-16">
                          اولویت
                        </th>

                        <th className="whitespace-nowrap text-center">
                          عنوان اسلاید
                        </th>

                        <th className="whitespace-nowrap text-center">
                          عملیات
                        </th>
                      </tr>
                    </thead>

                    {slides && slides.length > 0 && (
                      <SortableList
                        items={slides}
                        onSortEnd={onSortEnd}
                        setItem={(item) => {
                          setItem(item);
                        }}
                        setShowEditSlide={(value) => setShowEditSlide(value)}
                        handleDeleteSlide={handleDeleteSlide}
                      />
                    )}
                  </table>
                </div>
              </div>
              {/* slides List */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const SortableList = SortableContainer((props) => {
  const { items, handleDeleteSlide } = props;

  return (
    <tbody>
      {items.map((item, index) => (
        <SortableItem
          key={`item-${index}`}
          index={index}
          item={item}
          setItem={props.setItem}
          setShowEditSlide={props.setShowEditSlide}
          handleDeleteSlide={handleDeleteSlide}
        />
      ))}
    </tbody>
  );
});
const SortableItem = SortableElement((props) => {
  const { item, handleDeleteSlide } = props;
  return (
    <tr className="intro-x cursor-pointer select-none">
      <td className="text-center">{item.order}</td>

      <td className="text-center">{item.translations.fa.title}</td>

      <td className="text-center">
        <button
          className="flex items-center ml-3 cursor-pointer"
          onClick={() => {
            props.setItem(item);
            props.setShowEditSlide(true);
          }}
        >
          <Icons.CheckSquare className="w-4 h-4 mb-2 ml-1" />
          ویرایش
        </button>

        <button
          className="flex items-center text-theme-6 cursor-pointer"
          // eslint-disable-next-line no-undef
          onClick={() => handleDeleteSlide(item?.id)}
        >
          <Icons.Trash2 className="w-4 h-4 ml-1 " />
          حذف
        </button>
      </td>
    </tr>
  );
});
